import { getRouteApi } from '@tanstack/react-router';
import { LedgerActivityReportLedgerType } from '@mews-commander/data-access';
import { lt } from '@mews/framework';

export const ORDERED_LEDGER_TABLES = [
    {
        ledgerType: LedgerActivityReportLedgerType.Revenue,
        title: lt('Revenue'),
        showTotalCard: true,
        totalCardTitle: lt('LedgerActivityReportRevenueCardTitle'),
    },
    {
        ledgerType: LedgerActivityReportLedgerType.NonRevenue,
        title: lt('NonRevenue'),
        showTotalCard: true,
        totalCardTitle: lt('LedgerActivityReportNonRevenueCardTitle'),
    },
    { ledgerType: LedgerActivityReportLedgerType.Payments, title: lt('PaymentPlural'), showTotalCard: true },
    { ledgerType: LedgerActivityReportLedgerType.Outlets, title: lt('OutletPlural'), showTotalCard: true },
    { ledgerType: LedgerActivityReportLedgerType.Deposit, title: lt('DepositLedger'), showTotalCard: false },
    { ledgerType: LedgerActivityReportLedgerType.Guest, title: lt('GuestLedger'), showTotalCard: false },
    { ledgerType: LedgerActivityReportLedgerType.City, title: lt('CityLedger'), showTotalCard: false },
];

export const LedgersActivityReportRoute = getRouteApi(
    '/_authenticated/$currentEnterpriseId/LedgerActivityReport/Index/'
);
